import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout } from "antd";
import ProtectedRoute from "./ProtectedRoute";
import SideBaruser from "./sideBar";
import Clientdashboard from "../client/clientdashboard";
import Loginclient from "../loginclient/loginclient";
import Clientproduct from "../client/clientproductmangement/clientproduct";
import UpdateClientProduct from "../client/clientproductmangement/updateClientProduct";
import ClientProfile from "../client/clientProfile/clientProfile";
import OfferManagementClient from "../client/offerManagement/offerManagement";
import ViewActiveOfferClient from "../client/offerManagement/viewActiveOffer";

const ClientNavigation = () => {
  const user = useSelector((state: any) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const { Sider, Content } = Layout;
  return (
    <Layout>
      <Sider
        style={{ backgroundColor: "#FF1A1A", height: "100vh" }}
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? 40 : 250}
      >
        <SideBaruser
          collapsed={collapsed}
          doCollapse={() => setCollapsed(!collapsed)}
        />
      </Sider>
      <Content style={{ background: "#fff" }}>
        <Routes>
          {/* Redirect root (/) to /login if the user is not authenticated */}
          <Route path="/client" element={<Loginclient />} />

          <Route
            path="/clientDashboard"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <Clientdashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientProduct"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <Clientproduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientProduct/updateproduct/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateClientProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientProfile"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <ClientProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/offeronproduct"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <OfferManagementClient />
              </ProtectedRoute>
            }
          />
          <Route
            path="/viewActiveOfferclient"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <ViewActiveOfferClient />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Content>
    </Layout>
  );
};

export default ClientNavigation;
